/* eslint-disable no-underscore-dangle */
import React from 'react';
import { trans } from '@spotahome/soyuz/client';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';
import { AppBanner as AppBannerComponent } from '@spotahome/ui-library';

import { MQ_MOBILE_MAX_WIDTH } from '../constants';

const buildDeeplink = (slug = '') => {
  const sessionId =
    typeof window !== 'undefined' && window.__CONTEXT__
      ? window.__CONTEXT__.__EXPERIMENTS_SESSION_ID__
      : '';
  return `https://spotahome.app.link/${slug}${
    sessionId && `?webSessionId=${sessionId}`
  }`;
};
const AppBanner = () => (
  <NoSSR>
    <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
      <AppBannerComponent
        title={trans('appbanner.title')}
        eventAction="banner-click-homepage"
        openPath={buildDeeplink('banner_home')}
      />
    </MediaQuery>
  </NoSSR>
);

export default AppBanner;
